module.exports = __webpack_public_path__ + "img/6aaa20065a6d8874947bdaedb91b82b5.e7cff32e.jpg";